import { asNumber, asObject, asRaw, asString } from './guards'
import { ExternalPlatform } from './external-platform'

/** Port of constructors/objective.js — an entry action a giveaway can require. */
export class Objective {
  id: number | null
  endpoint: string | null
  endpoint_action: string | null
  external_platform_id: number | null
  external_platform: ExternalPlatform | null
  name: string | null
  steps: number | null

  constructor(data: unknown = {}) {
    const d = asRaw(data)
    this.id = asNumber(d.id)
    this.endpoint = asString(d.endpoint)
    this.endpoint_action = asString(d.endpoint_action)
    this.external_platform_id = asNumber(d.external_platform_id)
    this.external_platform = asObject(d.external_platform)
      ? new ExternalPlatform(d.external_platform)
      : null
    this.name = asString(d.name)
    this.steps = asNumber(d.steps)
  }

  /** Earns entries for referring people, rather than for an action elsewhere. */
  get is_referral(): boolean {
    return this.endpoint === OBJECTIVE_ENDPOINT_REFERRAL
  }
}

export const OBJECTIVE_ENDPOINT_REFERRAL = 'referral'
